import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import type { Constructor } from '@whispli/types';

export class __Locale extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly code!: string;
  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly name!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use localizedName
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private localized_name!: string | null;

  @Expose({groups: ['client']})
  public get localizedName() {
    return this.localized_name
  }

  public set localizedName(value) {
    this.localized_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private created_at!: string | null;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private updated_at!: string | null;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }
}
export type Locale = Omit<__Locale, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'localized_name' | 'created_at' | 'updated_at'>
export const Locale = __Locale as any as Constructor<Locale>
